import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { Reporte } from '../../../../models'
import { calcularAnioMesDia } from '../../../../utils/CalculoAnioMesDia'
import { AppConstantes, AppMapas } from '../../../../utils/Constantes'
import dayjs from '../../../../utils/DayjsUtil'
import { Recordatorio } from '../../../recordatorios/models'
import { Autorizacion } from '../../models'

type Props = {
  autorizacion: Autorizacion
  setMostrarModalRecordatorio: (arg: boolean) => void
  setMostrarModalReporte: (arg: boolean) => void
}
export const DetalleAutorizacionCardAutorizacion = ({
  autorizacion,
  setMostrarModalRecordatorio,
  setMostrarModalReporte,
}: Props) => {
  // Estas callbacks sólo levantan el estado al contenedor. El detalle resuelve el modal.
  const mostrarModalRecordatorio = () => {
    setMostrarModalRecordatorio(true)
  }
  const mostrarModalReporte = () => {
    setMostrarModalReporte(true)
  }
  return (
    <div className=' col-4 '>
      <div id='collapseAutorizacion'>
        <div className='card  condicionantes-autorizacion card-height'>
          <div className='card-header align-items-center pe-3 px-3 mx-0 '>
            <div>
              <h3 className='mt-2 ' style={{ maxWidth: '70%' }}>
                {autorizacion?.descAutorizacion}
                <span
                  className={`fs-6 mx-2 badge text-wh badge-${
                    AppMapas.MAPA_ESTATUS_AUTORIZACION_DETALLE.get(autorizacion.estatus) ?? 'dark'
                  }`}>
                  {autorizacion?.descEstatus}
                </span>
              </h3>
            </div>
            <div className='d-flex position-absolute mt-4 me-4 top-0 end-0'>
              <OverlayTrigger placement={'top'} overlay={<Tooltip>Abrir recordatorios</Tooltip>}>
                <button
                  className='btn btn-outline-primary btn-icon btn-circle btn-sm'
                  type='button'
                  onClick={() => {
                    mostrarModalRecordatorio()
                  }}>
                  <i className='fa-sharp fa-solid fa-bell fs-3'></i>
                </button>
              </OverlayTrigger>{' '}
              <OverlayTrigger
                placement={'top'}
                overlay={<Tooltip>Abrir documentos asociados</Tooltip>}>
                <button
                  className='btn btn-outline-primary btn-icon btn-circle btn-sm'
                  type='button'
                  onClick={() => {
                    mostrarModalReporte()
                  }}>
                  <i className='fa-sharp fa-solid fa-file fs-3'></i>
                </button>
              </OverlayTrigger>
            </div>
          </div>
          <div className=' overflow-auto card-body pb-0 pt-0 px-4 justify-content-between flex-column position-relative card-height-autorizacion  '>
            {/* DATOS AUTORIZACIÓN */}
            <div className='fw-semibold text-gray-600 fs-5 mb-5'>
              <div className='  mt-5  d-flex justify-content-between'>
                <p className=' text-gray-600'>Emisión </p>
                <p className='fw-bold  text-gray-700'>
                  {dayjs(autorizacion?.fechaEmision).format(AppConstantes.FORMATO_FECHA)}
                </p>
              </div>
              <div className='  d-flex justify-content-between text-end'>
                <p className=' text-gray-600'>Vencimiento</p>
                <p className='fw-bold  text-gray-700'>
                  {autorizacion?.fechaVencimiento ? (
                    dayjs(autorizacion.fechaVencimiento).format(AppConstantes.FORMATO_FECHA)
                  ) : (
                    <em className='text-gray-700 mx-1'>Sin vencimiento</em>
                  )}
                </p>
              </div>

              <div className='  d-flex justify-content-between text-end'>
                <p className=' text-gray-600'>Emisión de última renovación</p>
                <p className='fw-bold  text-gray-700'>
                  {autorizacion?.fechaUltimaRenovacion ? (
                    dayjs(autorizacion?.fechaUltimaRenovacion).format(AppConstantes.FORMATO_FECHA)
                  ) : (
                    <em className='text-gray-700 mx-1'>Sin última renovación</em>
                  )}
                </p>
              </div>
              <div className=' d-flex justify-content-between text-end'>
                <p className=' text-gray-600'>Vigencia</p>
                <p className='fw-bold text-end  text-gray-700' style={{ maxWidth: '60%' }}>
                  {!autorizacion.esIndefinida ? (
                    <>
                      {autorizacion.esPorFechaVencimiento ? (
                        <>
                          {/*
                            Vigencia calculada por diferencia fechaEmision->fechaVencimiento.
                            `calcularAnioMesDia` regresa una representación por unidades.
                          */}
                          {
                            calcularAnioMesDia(
                              dayjs(autorizacion.fechaEmision).format(
                                AppConstantes.FORMATO_FECHA_CALCULO_ANIO_MES_DIA
                              ),
                              dayjs(autorizacion.fechaVencimiento).format(
                                AppConstantes.FORMATO_FECHA_CALCULO_ANIO_MES_DIA
                              )
                            )[0]
                          }
                        </>
                      ) : (
                        <>
                          {/* Vigencia por duración (cantidad + unidadDuracion). */}
                          {autorizacion.cantidadDuracion}{' '}
                          {AppMapas.MAPA_UNIDAD_DURACION_AUTORIZACION_DESCRIPCIONES.get(
                            autorizacion.unidadDuracion
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    <em className='text-gray-700'>Sin duración</em>
                  )}
                </p>
              </div>
              <div className='text-start  me-0  d-flex justify-content-between text-end'>
                <p className='text-gray-600'>Competencia</p>
                <p className=' fw-bold text-end  text-gray-700'>{autorizacion?.descCompetencia} </p>
              </div>

              <div className='text-start  me-0  d-flex justify-content-between'>
                <p className=' text-gray-600 '>Dependencia</p>
                <p className='fw-bold text-end  text-gray-700 mt-1' style={{ maxWidth: '40%' }}>
                  {autorizacion?.dependencia}
                </p>
              </div>
            </div>
            {/* DATOS SITIO */}
            <div className='fw-semibold text-gray-600 fs-5 gy-1 mb-5'>
              <div className='pt-5'>
                <p className=' fs-3 text-start text-gray-900 fw-bold'>Sitio</p>
              </div>
              <div className='separator'></div>
              <div className='flex-fill me-0  mt-3 mb-1 d-flex justify-content-between'>
                <p className=' text-gray-600'>Nombre</p>
                <p className='fw-bold  text-gray-700'>{autorizacion?.nombreSitio}</p>
              </div>
              <div className=' text-start d-flex flex-fill me-0  mt-1 mb-1 justify-content-between'>
                <p className=' text-gray-600'>Razón Social </p>
                <p
                  className='fw-bold text-end  text-gray-700 card-autorizacion-maxwidth'
                  style={{ maxWidth: '40%' }}>
                  {autorizacion?.descRazonSocialSitio}
                </p>
              </div>
              <div className='flex-fill me-0  mt-1 mb-1 d-flex justify-content-between'>
                <p className=' text-gray-600'>RFC</p>
                <p className='fw-bold  text-gray-700'>{autorizacion?.rfcSitio}</p>
              </div>
              <div className='flex-fill me-0  mt-2  d-flex justify-content-between'>
                <p className=' text-gray-600'>Usuario asignado</p>
                <p className='fw-bold  text-end  text-gray-700' style={{ maxWidth: '40%' }}>
                  {autorizacion?.nombreContactoSitio}
                </p>
              </div>
            </div>
            {/* DATOS REPORTES */}
            <div className=' text-start d-flex flex-fill me-0  mt-1 pt-5 justify-content-between'>
              <p className=' fs-3 text-start text-gray-900 fw-bold'>Documentos asociados</p>

              {autorizacion?.reportes?.length > 0 && (
                <p className=' text-end  text-gray-600 card-autorizacion-maxwidth'>
                  Total registrados | {autorizacion?.reportes.length}
                </p>
              )}
            </div>
            <div className='separator'></div>
            {/* DATOS RECORDATORIOS */}
            {autorizacion?.reportes?.length === 0 ? (
              <div style={{ marginTop: '2vh', marginBottom: '1vh' }}>
                <div className=' d-flex justify-content-center ms-5 '>
                  <i className='bi bi-file-earmark font-size-icon'></i>
                </div>
                <div className='d-flex justify-content-center ms-5 mt-2'>
                  <i style={{ fontSize: '1em' }}>Sin documentos asociados</i>
                </div>
              </div>
            ) : (
              <div className='text-end mb-5 '>
                {autorizacion?.reportes?.map((reporte: Reporte, index: number) => (
                  <div
                    key={index}
                    className=' text-start d-flex flex-fill  mt-1 justify-content-between'>
                    <p className=' text-gray-600 mt-3'>{reporte.nombre}</p>
                    <OverlayTrigger placement={'top'} overlay={<Tooltip>Ver archivo</Tooltip>}>
                      <a
                        className='btn btn-outline-primary btn-icon btn-circle btn-sm '
                        href={reporte.ruta}
                        target='_blank'
                        rel='noopener noreferrer'>
                        <i className='fa-solid fa-arrow-up-right-from-square fs-4'></i>
                      </a>
                    </OverlayTrigger>
                  </div>
                ))}
              </div>
            )}
            <div className=' text-start d-flex flex-fill me-0  mt-1 pt-5 justify-content-between'>
              <p className=' fs-3 text-start text-gray-900 fw-bold'>Recordatorios</p>
              {autorizacion.recordatorios && autorizacion?.recordatorios?.length > 0 && (
                <p className=' text-end  text-gray-600 card-autorizacion-maxwidth'>
                  Total registrados | {autorizacion?.recordatorios?.length}
                </p>
              )}
            </div>
            <div className='separator'></div>
            {autorizacion?.recordatorios?.length === 0 ? (
              <div style={{ marginTop: '2vh', marginBottom: '3vh' }}>
                <div className=' d-flex justify-content-center ms-5 '>
                  <i className='  bi bi-bell font-size-icon'></i>
                </div>
                <div className='d-flex justify-content-center ms-5 mt-2'>
                  <i style={{ fontSize: '1em' }}>Sin recordatorios</i>
                </div>
              </div>
            ) : (
              <div className='text-end mb-7'>
                {autorizacion?.recordatorios?.map((recordatorio: Recordatorio, index: number) => (
                  <div key={index}>
                    {recordatorio.unidad !== AppConstantes.CVE_UNIDAD_RECORDATORIO_PERSONALIZADO ? (
                      <div className=' text-start d-flex flex-fill  mt-1 justify-content-between'>
                        <p className=' text-gray-600  fs-5'>
                          {recordatorio.cantidad} {recordatorio.descUnidad} antes
                        </p>
                        <p className=' text-gray-600  fs-5'>
                          {/* La hora/minuto se renderiza desde dayjs (sin padding excepto minutos). */}
                          {dayjs(recordatorio.fechaRecordatorio).format(
                            AppConstantes.FORMATO_FECHA
                          )}{' '}
                          a las {dayjs(recordatorio.fechaRecordatorio).hour()}:
                          {dayjs(recordatorio.fechaRecordatorio).minute() <= 10
                            ? '0' + dayjs(recordatorio.fechaRecordatorio).minute()
                            : dayjs(recordatorio.fechaRecordatorio).minute()}{' '}
                          hrs
                        </p>
                      </div>
                    ) : (
                      <div className=' text-start d-flex flex-fill  mt-1 justify-content-between'>
                        <p className=' text-gray-600  fs-5'>{recordatorio.descUnidad}</p>
                        <p className=' text-gray-600  fs-5'>
                          {/* Recordatorio personalizado: se muestra descUnidad + fecha/hora. */}
                          {dayjs(recordatorio.fechaRecordatorio).format(
                            AppConstantes.FORMATO_FECHA
                          )}{' '}
                          a las {dayjs(recordatorio.fechaRecordatorio).hour()}:
                          {dayjs(recordatorio.fechaRecordatorio).minute() <= 10
                            ? '0' + dayjs(recordatorio.fechaRecordatorio).minute()
                            : dayjs(recordatorio.fechaRecordatorio).minute()}{' '}
                          hrs
                        </p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
